import { render, staticRenderFns } from "./DiscordSVG.vue?vue&type=template&id=642c6b6a"
import script from "./DiscordSVG.vue?vue&type=script&lang=ts"
export * from "./DiscordSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports